
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[orderMethod]/[venueXRefID]/menu",
      function () {
        return require("private-next-pages/[orderMethod]/[venueXRefID]/menu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[orderMethod]/[venueXRefID]/menu"])
      });
    }
  